import { cn } from "../../../lib/utils"

export interface DeterminateProgressBarProps {
  /** 0–100 */
  percent: number
  isPaused?: boolean
}

export function DeterminateProgressBar({ percent, isPaused = false }: DeterminateProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, percent))

  return (
    <div className="relative h-2 w-full overflow-hidden rounded-full bg-primary/10" aria-hidden="true">
      <span
        className={cn(
          "absolute inset-y-0 left-0 rounded-full",
          isPaused ? "bg-muted-foreground/35" : "bg-primary",
          "transition-[width] duration-500 ease-out",
        )}
        style={{ width: `${clamped}%` }}
      />
    </div>
  )
}
